import React, { ReactNode } from 'react'
import ReactJsonImport from 'react-json-view'
import { unwrapCjsDefault } from '../../../pure-js/libs/unwrapCjsDefault'
import './JsonModal.css'

/**
 * Same trap as admin-web's JsonModal: `react-json-view` is CJS (`__esModule` +
 * `exports.default`), so Rolldown returns the module namespace instead of the component
 * and rendering it throws React error #130. user-web is still on Vite 6 (Rollup), where
 * this unwrap is a no-op — it is here so the bump to Vite 8 is not another outage.
 */
const ReactJson = unwrapCjsDefault(ReactJsonImport)

interface JsonModalProps {
  open: boolean
  onClose: () => void
  data: unknown
  title?: ReactNode
}

// Custom theme for high-contrast light text on dark background
const customTheme = {
  base00: '#32364f', // modal background
  base01: '#23243a',
  base02: '#23243a',
  base03: '#e0e0e0', // line numbers, secondary text
  base04: '#f5f5f5', // keys
  base05: '#ffffff', // main text (values)
  base06: '#f5f5f5',
  base07: '#ffffff',
  base08: '#ffb86c', // numbers
  base09: '#f1fa8c', // booleans
  base0A: '#8be9fd', // null
  base0B: '#50fa7b', // strings
  base0C: '#8be9fd', // dates
  base0D: '#bd93f9', // object keys
  base0E: '#ff79c6', // function
  base0F: '#f8f8f2'
}

const JsonModal: React.FC<JsonModalProps> = ({ open, onClose, data, title }) => {
  if (!open) return null
  return (
    <div className="json-modal-overlay" onClick={onClose}>
      <div className="json-modal" onClick={(e) => e.stopPropagation()}>
        <button className="json-modal-close" onClick={onClose} aria-label="Close JSON view">
          ×
        </button>
        {title && <div className="json-modal-title">{title}</div>}
        <div className="json-modal-jsonview">
          <ReactJson
            src={data as object}
            name={false}
            collapsed={1}
            enableClipboard={true}
            displayDataTypes={false}
            displayObjectSize={false}
            style={{
              fontSize: '12px',
              fontFamily: 'Fira Mono, Menlo, Consolas, monospace',
              textAlign: 'left',
              lineHeight: '1.25',
              color: '#fff'
            }}
            theme={customTheme}
          />
        </div>
      </div>
    </div>
  )
}

export default JsonModal
